import VueSignals from '@/scripts/VueSignals';
const mime = require('mime-types');

export default {
    name: 'MediaModal',
    data() {
        return {
            url: '',
            type: '',
        }
    },
    mounted() {
        if (this.$parent.data) {
            this.url = this.$parent.data.url;
            this.type = this.computeFileType(this.url);
        }
    },
    methods: {
        computeFileType(url) {
            let contentType = mime.lookup(url);
            if (!contentType) {
                contentType = mime.contentType(url);
            }
            // TODO(Alex): Maybe there is a faster solution with a regex
            if (contentType.includes('image')) {
                return 'image';
            } else if (contentType.includes('video')) {
                return 'video';
            } else {
                return '';
            }
        }
    }
}
